export default function loading(
  state = {
    status: 0
  },
  action = {}
) {
  switch (action.type) {
    case 'SHOW_LOADING':
      return Object.assign({}, state, {
        status: state.status + 1
      })
    case 'HIDE_LOADING':
      return Object.assign({}, state, {
        status: state.status > 1 ? state.status - 1: 0
      })
    default:
      return state
  }
}
